import React from 'react';
import { ReactComponent as IconoMovil } from '.././imagenes/movil.svg';

const IconoMovilEstado = ({estado,idl}) => {
    const ida = 'icon'+idl
    switch(estado){
        case 'Programado':
            return <IconoMovil fill="orange" id = {ida} />;
        case 'Asignado' :
            return <IconoMovil fill="blue" id = {ida} />;
        case 'Preasignado' :
            return <IconoMovil fill="yellow" id = {ida} />;    
        case 'Activo' :
            return <IconoMovil fill="green" id = {ida} />;
        case 'Terminado' :
            return <IconoMovil fill="green"/>;
        case 'Solicitado' :
            return <IconoMovil fill="red"/>;
        default :
            return <IconoMovil/>;
    }
}
export default IconoMovilEstado;
